import { render, staticRenderFns } from "./MyDocumentDetails.vue?vue&type=template&id=744a9fd8&scoped=true&"
import script from "./MyDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./MyDocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentDetails.vue?vue&type=style&index=0&id=744a9fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a9fd8",
  null
  
)

export default component.exports